export default "__VITE_PUBLIC_ASSET__2718cef4__"